module.exports = __webpack_public_path__ + "static/Treant-75b8162b0436bf927a74600d9926612a.jpg";